import { useEffect } from "react";

const SESSION_KEY = "flowmindai-crisp-pricing-shown";

/**
 * Crisp proactive message — fires once per session when the user has been
 * looking at the pricing section for 30 seconds.
 * No-op if Crisp isn't loaded yet (e.g. cookie consent denied).
 */
export default function CrispProactive() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const target = document.getElementById("pricing");
    if (!target) return;

    let timer = null;

    const fire = () => {
      try {
        if (!window.$crisp) return;
        window.$crisp.push([
          "do",
          "message:show",
          [
            "text",
            "👋 Une question sur nos plans ? Je suis Marie, je peux vous aider à choisir le bon plan pour votre PME.",
          ],
        ]);
        sessionStorage.setItem(SESSION_KEY, new Date().toISOString());
        observer.disconnect();
      } catch (e) {
        // silent
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
            if (!timer) {
              timer = setTimeout(fire, 30000);
            }
          } else {
            if (timer) {
              clearTimeout(timer);
              timer = null;
            }
          }
        });
      },
      { threshold: [0.3] },
    );

    observer.observe(target);

    return () => {
      if (timer) clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return null;
}
